import AvatarInitials from './avatar-initials';

export type { AvatarInitialsProps } from './avatar-initials.types';
export default AvatarInitials;
